module.exports = __webpack_public_path__ + "static/media/editDining.7f59b6c5.svg";